'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import passRules from '../../modules/passRules';
import { recaptchaUpdater } from '../../modules/recaptcha';
import { stateCity, area, unity, stores, cdType, funcional, funcionalByWorkplace } from '../../modules/select';

const showRegistrationForm = {
  bindActions() {
    $(document).on('change', '.js-workplace', function (e) {
      let selected = $(this).val();

      if (selected == 1) {
        //loja
        $('#cd_type').hide();
        $('#district').show();
        $('#store').show();
        $('#funcional_category').show();
        $('#area').hide();
        $('#store-profile').show();
        $('.js-radio-type').eq(0).prop('checked', true);
        $('#zone_wrapper').hide();
      } else if (selected == 2) {
        // EC
        $('#cd_type').hide();
        $('#district').hide();
        $('#store').hide();
        $('#funcional_category').show();
        $('#area').show();
        $('#store-profile').hide();
        $('.js-radio-type').prop('checked', false);
        $('#zone_wrapper').show();
      } else if (selected == 6) {
        // CD
        $('#cd_type').show();
        $('#district').hide();
        $('#store').hide();
        $('#funcional_category').show();
        $('#area').hide();
        $('#store-profile').hide();
        $('.js-radio-type').prop('checked', false);
        $('#zone_wrapper').show();
      }
    });

    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');
      let $steps = $('.js-steps');

      if (currentSlide == 'first') {
        if (
          ($("input[name='volunteer_type']:checked").val() == null && $('.js-workplace').val() == 1) ||
          $("input[name='cpf']").val() == '' ||
          $("input[name='name']").val() == '' ||
          $("input[name='birthdate']").val() == '' ||
          $("input[name='birthdate']").val().length < 10 ||
          !$('[name="volunteer_type_select"]').val() ||
          $('#cpf-error').hasClass('error')
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide === 'state') {
        if ($('#js-state-filter') == '' || $('#js-cities').val() == '' || $('#js-cities').val() == 0) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');

          return false;
        }
      }

      if (currentSlide === 'rede') {
        let userType = $('.js-workplace').val(),
          unity = $('.js-unities').val(),
          store = $('.js-stores').val(),
          funcional = $('.js-funcional').val(),
          enrollment = $("[name='enrollment']").val(),
          area = $('.js-areas').val(),
          cd = $('.js-cd-type').val();

        // 1 - Loja / 2 - EC / 6 - CD
        if (
          (userType == 1 && (!unity || !store || !funcional || !enrollment)) ||
          (userType == 2 && (!area || !funcional || !enrollment)) ||
          (userType == 6 && (!cd || !funcional || !enrollment))
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide === 'contact') {
        if (
          $("input[name='email']").val() == '' ||
          $("input[name='mobile_phone']").val() == '' ||
          $("input[name='email']").hasClass('error') ||
          $("input[name='mobile_phone']").val().length < 14
        ) {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide === 'habilities') {
        if (APP.vars.selectHabilities.val() === '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (currentSlide === 'etnical') {
        if ($('[name="gender_identity"]').val() == '' || $('[name="racial_identity"]').val() == '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
        if ($('#zone_wrapper').is(':visible') && $('[name="zone"]').val() == '') {
          Swal.fire('Atenção!', 'Preencha os campos corretamente', 'error');
          return false;
        }
      }

      if (nextSlide === 'rede') {
        if (
          $("input[name='volunteer_type']:checked").val() === 'employee' ||
          $("input[name='volunteer_type']:checked").val() === 'provider'
        ) {
          nextSlide = 'rede';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
      $steps.find(`[data-step="${nextSlide}"]`).addClass('active');
    });

    $('.back').click(function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');
      let $steps = $('.js-steps');

      if (nextSlide == 'rede') {
        if (
          $("input[name='volunteer_type']:checked").val() == 'employee' ||
          $("input[name='volunteer_type']:checked").val() == 'provider'
        ) {
          nextSlide = 'rede';
        } else {
          nextSlide = 'state';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
      $steps.find(`[data-step="${currentSlide}"]`).removeClass('active');
    });

    $('.js-rede').on('change', function () {
      if ($("input[name='is_rede']:checked").val() == '1') {
        $('#is_rede_options').removeClass('u-display--none');
        $('#is_regional_options').removeClass('u-display--none');
      } else {
        $('#is_rede_options').addClass('u-display--none');
        $('#is_regional_options').addClass('u-display--none');
      }
    });

    $('.js-form-cpf').on('change keyup paste', function (e) {
      e.preventDefault();

      var cpf = $(this).val();
      if (cpf != '') {
        var validacpf = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/;

        if (validacpf.test(cpf)) {
          getCpf(cpf);
        } else {
          $('#cpf-error').text('');
          $('#cpf-error').removeClass('error');
        }
      }
    });

    function getCpf(cpf) {
      var url = '/check-cpf/' + cpf;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#cpf-error').text(response.message);
            $('#cpf-error').addClass('error');
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $('.js-form-email').on('change keyup paste', function (e) {
      e.preventDefault();

      var email = $(this).val();
      if (email != '') {
        getEmail(email);
      }
    });

    function getEmail(email) {
      var url = '/check-email/' + email;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('.js-form-email').addClass('error');
            $('#email-error').text(response.message);
          } else {
            $('.js-form-email').removeClass('error');
            $('#email-error').text('');
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $(document).on('click', '#btn-register', function (e) {
      e.preventDefault();

      if (!passRules.settings.submit) {
        Swal.fire('Preencha uma senha válida!', '', 'error');
      } else {
        let checkLength = $('.js-check').length;

        if ($('.js-check:checked').length === checkLength) {
          $('#form-signin').submit();
        } else {
          Swal.fire('Você deve aceitar os termos para continuar!', '', 'error');
        }
      }
    });
  },

  init() {
    _this.bindActions();
    passRules.init();
    recaptchaUpdater('register');
    stateCity();
    area();
    unity();
    stores();
    cdType();
    funcional();
    funcionalByWorkplace();
  },
};

const s = showRegistrationForm.settings,
  _this = showRegistrationForm;

export default _this;
